import React from "react";

const years = ["2023-2024", "2024-2025", "2025-2026", "2026-2027"];

const items = [
    { title: "Seat Matrix", file: "01-Seat-Matrix.pdf" },
    { title: "Infrastructure Details", file: "02-Infrastructure-Details.pdf" },
    { title: "Trust Deed and Registration Certificate", file: "03-Trust-Deed-Registration-Certificate.pdf" },
    { title: "Library Details", file: "04-Library-Details.pdf" },
    { title: "Clinical Material In Hospital", file: "05-Clinical-Material-In-Hospital.pdf" },
    { title: "Details of Equipment and Instruments", file: "06-Details-of-Equipment-and-Instruments.pdf" },
    { title: "Total Teaching Staff Information as per MSR", file: "07-Total-Teaching-Staff-Information-as-per-MSR.pdf" },
    { title: "Total Subject Wise Teachers List", file: "08-Subject-Wise-Teaching-Staff.pdf" },
    { title: "Non-teaching Staff", file: "09-Non-Teaching-Staff.pdf" },
    { title: "Guest Faculty", file: "10-Guest-Faculty.pdf" },
    { title: "Webinar Workshop", file: "11-Webinar_Workshop.pdf" },
    {
        title: "Information of Biometrics Attendance, Research Articles, Students Welfare Schemes",
        file: "12-Information-of-Biometrics-Attendance.pdf",
    },
    { title: "AISHE Certificate", file: "13-AISHE-Certificate.pdf" },
    { title: "Declaration by Principal of the College", file: "14-Declaration-by-Principal-of-the-College.pdf" },
];

const MUHS = () => {
  return (
    <div className="p-3 sm:p-6 font-serif bg-gray-50">

        {/* Mobile scroll wrapper */}
        <div className="overflow-x-auto">

            {/* Responsive Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 min-w-[280px]">

                {years.map((year) => (
                    <div
                        key={year}
                        className="bg-white border shadow-md p-3 sm:p-4 text-center"
                    >
                        {/* Column Header */}
                        <h2 className="text-base sm:text-xl font-semibold mb-4">
                            MUHS Mandate {year}
                        </h2>

                        {items.map((item, index) => (
                            <div key={index} className="mb-5">
                                <p className="mb-2 text-sm leading-snug">
                                    {item.title}
                                </p>

                                <a
                                    href={`/pdfs/${year}/${encodeURIComponent(item.file)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block bg-blue-600 text-white px-4 py-2 text-xs sm:text-sm font-semibold rounded hover:bg-blue-700 transition"
                                >
                                    Download PDF
                                </a>
                            </div>
                        ))}
                    </div>
                ))}

            </div>
        </div>
    </div>
);
};

export default MUHS;